import React, { Component } from 'react';
import axios from "axios";
// import {appConfig} from "./../tools/AppConfig";
import Waiting from './waiting';
import { appConfig } from '../../../../tools/AppConfig';
import ImageSelectPreview from 'react-image-select-pv';
import {Header, Message, Button} from './lucky_components';
import LuckyResult from './LuckyResult';
import PaymobCard from './../../components/card/card';
import Popup_3d_secure from './../../components/popup_3d_secure/popup_3d_secure';
import errorIcon from './lucky_components/components/molecules/Message/error.svg';
import { UncontrolledCollapse, Card, CardBody } from 'reactstrap';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import './lucky.css';
const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const Cvv = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 3 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter valid CVV.</div>;
    }
};
class lucky extends Component {
    constructor(props){
        super(props);
        this.state = {
            lucky_result: false,
            lucky_result_error: false,
            lucky_result_data: {},
            inner_waiting: false,
            current_action: "",
            current_action_message: "",
            lucky_info: {},
            front_national_id_image: null,
            back_national_id_image: null,
            new_card_payment_token: "",
            saved_cards: null,
            open_payment_iframe: null,
            new_payment: false,
            new_card_payment_waiting: false,
            paymet_error: false,
            paymet_error_message: "",
            //3d_secure
            popup_3d_secure: false,
            popup_3d_secure_url: "",
            //auth
            ref: "",
            //card
            cvc: '',
            expiry: '',
            focus: '',
            name: '',
            number: '',
            //public
            waiting: true,
            error: false,
            error_head: "",
            error_message: ""
        };
    }
    componentDidMount(){
        const popup_3d_secure_interval = setInterval(()=>{
            if(localStorage.popup_3d_secure){
                clearInterval(popup_3d_secure_interval);
                localStorage.removeItem("popup_3d_secure");
                this.setState({
                    popup_3d_secure: false,
                    popup_3d_secure_url: "",
                    waiting: true,
                },()=>{
                    this.load_result();
                })
            }
        }, 500);
        var url_string = window.location.href;
        var url = new URL(url_string);
        var ref = url.searchParams.get("ref");
        let lucky_result  = url.searchParams.get("result");
        this.setState({ref: ref}, () => {
            if(lucky_result){
                this.load_result();
            }else if(ref){
                this.load_data();
            }else{
                this.create_customer_url();
            }
        })
    }
    create_customer_url = () =>{
        let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "payment_token": this.props.payment_token,
            "source": {
                "subtype": "LUCKY",
                "identifier": "LUCKY"
            }
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            if(resp.data.pending == true && resp.data.data && resp.data.data.redirect_url){
                window.location.href = resp.data.data.redirect_url;
            }else{
                this.setState({waiting: false, error: true, error_head: "error", error_message: "can't get customer url."});
            }
        })
        .catch((err)=>{
            this.setState({waiting: false, error: true, error_head: "error", error_message: "can't get customer url."});
        });
    }
    load_result = () =>{
        let url = appConfig.getServerUrl() + '/api/acceptance/lucky-installments/transaction';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "payment_token": this.props.payment_token,
            "ref": this.state.ref
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            this.setState({waiting: false, lucky_result: true , lucky_result_error: false, lucky_result_data: resp.data});
        })
        .catch((err)=>{
            this.setState({waiting: false, lucky_result: true , lucky_result_error: true, lucky_result_data: {}});
        });
    }
    load_data = () => {
        let url = appConfig.getServerUrl() + '/api/acceptance/lucky-installments/ocr';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "payment_token": this.props.payment_token,
            "ref": this.state.ref
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            this.setState({
                waiting: false,
                lucky_info: resp.data,
                current_action: resp.data.action,
                new_card_payment_token: resp.data.new_card,
                saved_cards: resp.data.saved,
                current_action_message: resp.data.message,
                new_payment: resp.data.saved && resp.data.saved.length > 0 ? false : true
            })
        })
        .catch((err)=>{
            if(err && err.response && err.response.data && err.response.data.message){
                if(err.response.data.message.message){
                    this.setState({waiting: false, current_action: "", current_action_message: err.response.data.message.message})
                }else{
                    this.setState({waiting: false, current_action: "", current_action_message: err.response.data.message})
                }
            }else if(err && err.response && err.response.data && err.response.data.detail){
                this.setState({waiting: false, current_action: "", current_action_message: err.response.data.detail})
            }else{
                this.setState({waiting: false, current_action: "", current_action_message: "Oops! Something went wrong. If this problem persists, please contact your service provider."})
            }
        });
    }
    upload_id = (e) => {
        e.preventDefault();
        this.setState({inner_waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/lucky-installments/ocr';
            let config = {
                // headers: {
                //     "Content-Type": "application/json",
                //     "Accept": "application/json"
                // }
            };
            // let data = {
            //     "payment_token": this.props.payment_token,
            //     "ref": this.state.ref,
            //     "front_national_id_image": this.state.front_national_id_image,
            //     "back_national_id_image": this.state.back_national_id_image
            // }
            // let jsonData = JSON.stringify(data);

            var dataFormData = new FormData();
            dataFormData.set('payment_token', this.props.payment_token);
            dataFormData.set('ref', this.state.ref);
            dataFormData.set('front_national_id_image', this.state.front_national_id_image);
            dataFormData.set('back_national_id_image', this.state.back_national_id_image);
            axios.post(
                url,
                dataFormData,
                config
            )
            .then((resp)=>{
                this.setState({
                    inner_waiting: false,
                    lucky_info: resp.data,
                    current_action: resp.data.action,
                    new_card_payment_token: resp.data.new_card,
                    saved_cards: resp.data.saved,
                    current_action_message: resp.data.message
                })
            })
            .catch((err)=>{
                if(err && err.response && err.response.data && err.response.data.message){
                    this.setState({inner_waiting: false, current_action: "", current_action_message: err.response.data.message, front_national_id_image: null, back_national_id_image: null})
                }else if(err && err.response && err.response.data && err.response.data.detail){
                    this.setState({inner_waiting: false, current_action: "", current_action_message: err.response.data.detail, front_national_id_image: null, back_national_id_image: null})
                }else{
                    this.setState({inner_waiting: false, current_action: "", current_action_message: "Oops! Something went wrong. If this problem persists, please contact your service provider.", front_national_id_image: null, back_national_id_image: null})
                }
            });
        })
    }
    render_upload_id = () => {
        return(
            <div className="header__container">
                <div className="upload_id_full_div">
                    <div className="id_steper"><span className={this.state.front_national_id_image ? "active" : ""}></span><span className={this.state.back_national_id_image ? "active" : ""}></span></div>
                    {(!this.state.front_national_id_image || !this.state.back_national_id_image) &&
                        <div className="id_text">
                            <p>Take a photo of the <b>{this.state.front_national_id_image ? "back" : "front"}</b> of your ID to help us identify you</p>
                            <p>Your privacy is very important to us. your data is sored securely.</p>
                        </div>
                    }
                    <ImageSelectPreview 
                        max={2}
                        imageTypes="png|jpg"
                        dropAreaText="Drag and drop and image"
                        buttonText="browse to choose a file"
                        onChange={ data => { 
                            let image_1 = null;
                            let image_2 = null;
                            if(data[0] && data[0].blob){
                                image_1 = data[0].blob;
                            }
                            if(data[1] && data[1].blob){
                                image_2 = data[1].blob;
                            }
                            this.setState({front_national_id_image: image_1, back_national_id_image: image_2}) 
                        } }
                    />
                    {(!this.state.front_national_id_image || !this.state.back_national_id_image) &&
                        <div className="id_text2">You'll only need to do this once.</div>
                    }
                    {this.state.front_national_id_image && this.state.back_national_id_image ?
                        <Button onClick={this.upload_id}>Next</Button>
                    :
                        <div><Button disabled={true}>Next</Button></div>
                    }
                </div>
            </div>
        )
    }
    render_lucky_messgae = () => {
        return (
            <div className="header__container">
                <Message copy={this.state.current_action_message} />
                <Button onClick={() => {this.setState({current_action: "upload_id"})}}>Upload a valid ID</Button>
            </div>
        )
    }
    iframe_open = (url) => {
        this.setState({open_payment_iframe: url})
    }
    //card
    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        
        this.setState({ [name]: value });
    }
    new_card_payment = (card_data) => {
        this.setState({new_card_payment_waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/tokenization?payment_token=' + this.state.new_card_payment_token;
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {   
				'pan': card_data.cardNumber,
				'expiry_month': card_data.expiry_mm,
				'expiry_year': card_data.expiry_yy,
				'cardholder_name': card_data.name
			}
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
                let config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    }
                };
                let data = {
                    "source": {
                    "identifier": card_data.cardNumber,
                    "sourceholder_name": card_data.name,
                    "subtype": "CARD",
                    "expiry_month": card_data.expiry_mm,
                    "expiry_year": card_data.expiry_yy,
                    "cvn": card_data.cvc
                    },
                    "payment_token":  this.state.new_card_payment_token
                }
                let jsonData = JSON.stringify(data);
                axios.post(
                    url,
                    jsonData,
                    config
                )
                .then((resp)=>{
                    if(resp.data.success == "true" || resp.data.pending == "true"){
                        this.handle_3d_secure(resp.data)
                    }else{
                        this.setState({paymet_error: true, paymet_error_message: "Payment faild!",new_card_payment_waiting: false})
                    }
                })
                .catch((err)=>{
                    this.setState({paymet_error: true, paymet_error_message: "Payment faild!",new_card_payment_waiting: false})
                });
            })
            .catch((err)=>{
                this.setState({paymet_error: true, paymet_error_message: "Payment faild!",new_card_payment_waiting: false})
            });
        })
    }
    saved_card_payment = (e, saved_card) => {
        e.preventDefault();
        let current_form_data = new FormData(e.target)
        let cvv = current_form_data.get("cvv")
        this.setState({waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                "identifier": saved_card.token,
                "subtype": "TOKEN",
                "cvn": cvv
                },
                "payment_token":  this.state.new_card_payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success == "true" || resp.data.pending == "true"){
                    this.handle_3d_secure(resp.data)
                }else{
                    this.setState({paymet_error: true, paymet_error_message: "Payment faild!",waiting: false})
                }
            })
            .catch((err)=>{
                this.setState({paymet_error: true, paymet_error_message: "Payment faild!",waiting: false})
            });
        })
    }
    handle_3d_secure = (trans_data) => {
        this.setState({popup_3d_secure: true, popup_3d_secure_url: trans_data.redirection_url})
    }
    render_payment = () => {
        if(this.state.paymet_error){
            return(
                <div className="header__container">
                    <Message copy={this.state.paymet_error_message} />
                    <Button onClick={() => {
                        this.setState(
                            {
                                paymet_error: false, 
                                paymet_error_message: "",
                                new_payment: false,
                                current_action: "",
                                new_card_payment_token: "",
                                saved_cards: null,
                                current_action_message: "",
                                waiting: true
                            },()=>{
                                this.load_data();
                        })}}>Try Again</Button>
                </div>
            )
        }else{
            if(this.state.new_payment){
                return(
                    <div className="header__container">
                        <div>
                            <p className="head_txt">Payment Cards</p>
                            <div className="lucky_card_component">
                                <PaymobCard 
                                    card_submit={this.new_card_payment}
                                    waiting={this.state.new_card_payment_waiting}
                                />
                            </div>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className="header__container">
                        <p className="head_txt">Payment Cards</p>
                        <div>
                            {this.state.saved_cards &&
                                this.state.saved_cards.map((saved_card) => {
                                    return(
                                        <div key={saved_card.id}>
                                            <div className="success_card_div select_option" id={"save_card_btn_" + saved_card.id}>
                                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.0721 2.93C15.6737 1.53118 13.8919 0.57847 11.952 0.192373C10.0121 -0.193724 8.0013 0.00413263 6.17386 0.76092C4.34643 1.51771 2.78446 2.79943 1.68551 4.44399C0.586566 6.08855 0 8.02206 0 10C0 11.9779 0.586566 13.9115 1.68551 15.556C2.78446 17.2006 4.34643 18.4823 6.17386 19.2391C8.0013 19.9959 10.0121 20.1937 11.952 19.8076C13.8919 19.4215 15.6737 18.4688 17.0721 17.07C18.0088 16.1462 18.7526 15.0455 19.2603 13.8318C19.7679 12.6181 20.0293 11.3156 20.0293 10C20.0293 8.68441 19.7679 7.38193 19.2603 6.16823C18.7526 4.95453 18.0088 3.85381 17.0721 2.93ZM8.91214 13.87C8.77399 14.0107 8.60895 14.1221 8.42685 14.1977C8.24475 14.2733 8.0493 14.3115 7.85214 14.31C7.65481 14.3127 7.45902 14.275 7.27675 14.1993C7.09448 14.1237 6.92958 14.0116 6.79214 13.87L4.00214 11.08L4.71214 10.38L7.49214 13.17C7.58729 13.2623 7.71461 13.3138 7.84714 13.3138C7.97966 13.3138 8.10699 13.2623 8.20214 13.17L15.2821 6.09L15.9821 6.8L8.91214 13.87Z" fill="#2CD18A"/>
                                                </svg>
                                                <p className="card_num">{saved_card.type} Card {saved_card.masked}</p>
                                                
                                            </div>
                                            <UncontrolledCollapse toggler={"save_card_btn_" + saved_card.id}>
                                                <Card>
                                                <CardBody>
                                                    <Form className="saved_card_form" onSubmit={(e) => {this.saved_card_payment(e, saved_card)}}>
                                                        <div className="input_con_div">
                                                            <Input type="number" pattern="[0-9]*" name="cvv" placeholder="CVV" required 
                                                                validations={[required, Cvv]} 
                                                            />
                                                        </div>
                                                        <VButton className="btn btn-primary active premBtn">Pay Now</VButton>
                                                    </Form>
                                                </CardBody>
                                                </Card>
                                            </UncontrolledCollapse>
                                        </div>
                                    )
                                })
                            }
                            <div className="success_card_div select_option" onClick={()=>{this.setState({new_payment: true})}}>
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.0721 2.93C15.6737 1.53118 13.8919 0.57847 11.952 0.192373C10.0121 -0.193724 8.0013 0.00413263 6.17386 0.76092C4.34643 1.51771 2.78446 2.79943 1.68551 4.44399C0.586566 6.08855 0 8.02206 0 10C0 11.9779 0.586566 13.9115 1.68551 15.556C2.78446 17.2006 4.34643 18.4823 6.17386 19.2391C8.0013 19.9959 10.0121 20.1937 11.952 19.8076C13.8919 19.4215 15.6737 18.4688 17.0721 17.07C18.0088 16.1462 18.7526 15.0455 19.2603 13.8318C19.7679 12.6181 20.0293 11.3156 20.0293 10C20.0293 8.68441 19.7679 7.38193 19.2603 6.16823C18.7526 4.95453 18.0088 3.85381 17.0721 2.93ZM8.91214 13.87C8.77399 14.0107 8.60895 14.1221 8.42685 14.1977C8.24475 14.2733 8.0493 14.3115 7.85214 14.31C7.65481 14.3127 7.45902 14.275 7.27675 14.1993C7.09448 14.1237 6.92958 14.0116 6.79214 13.87L4.00214 11.08L4.71214 10.38L7.49214 13.17C7.58729 13.2623 7.71461 13.3138 7.84714 13.3138C7.97966 13.3138 8.10699 13.2623 8.20214 13.17L15.2821 6.09L15.9821 6.8L8.91214 13.87Z" fill="#2CD18A"/>
                                </svg>
                                <p className="card_num">Use New Card</p>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }
  render_lucky_body = () => {
    return(
        <div>
            <div className="lucky_body">
                {this.state.lucky_result ?
                    <LuckyResult
                        lucky_result_error={this.state.lucky_result_error}
                        lucky_result_data={this.state.lucky_result_data}
                    />
                :
                    <>
                        {this.state.inner_waiting ? 
                            <Waiting height='300px' />
                        :
                            <div>
                                {this.state.current_action == "payment_flow" ?
                                    this.render_payment()
                                :
                                this.state.current_action == "upload_id" ?
                                    this.render_upload_id()
                                :
                                    this.render_lucky_messgae()
                                    //this.render_payment()
                                }
                            </div>
                        }
                    </>
                }
            </div>
        </div>
      )
  }
  render_lucky_error = () =>{
      return(
        <div className="lucky_body">
            <div className="header__container">
                <Message copy={this.state.error_message} icons={errorIcon} />
            </div>
        </div>
      )
  }
  render() {
    return(
        <div className="lucky_main">
            <Header />
            {this.state.waiting ?
                <Waiting height='300px' />
            :
                this.state.error ?
                    this.render_lucky_error()
                :
                    this.render_lucky_body()
            }
            {this.state.popup_3d_secure &&
                <Popup_3d_secure url={this.state.popup_3d_secure_url} />
            }
        </div>
    )
  }
}

export default lucky;